import { TopTimeSpenderTable } from './TopTimeSpenderTable'
import { withTopTimeSpenderTable } from './withTopTimeSpenderTable'

const Connected = withTopTimeSpenderTable(TopTimeSpenderTable)

export { Connected as TopTimeSpenderTable }
